module.exports = __webpack_public_path__ + "img/1791993049682.ba5faf87.png";